import { Articles } from "../../data/models/article";
import { useNavigate } from "react-router-dom";
import Routes from "router/routes";

const FeaturedArticles = ({ articles }: { articles: Articles[] }) => {
  const navigate = useNavigate();
  const featuredArticles = articles.filter(
    (article) => article.featured_article === true,
  );
  console.log(featuredArticles);

  return (
    <div className="mx-3 mb-5 mt-8 flex flex-col gap-x-9 lg:mx-[100px] lg:mb-8 lg:mt-14 lg:flex-row">
      <div className="flex-1">
        <div className="">
          {featuredArticles.length > 0 && (
            <div
              className="cursor-pointer"
              onClick={() =>
                navigate(Routes.BLOG_POST(featuredArticles[0].slug ?? ""), {
                  state: {
                    article: featuredArticles[0],
                  },
                })
              }
            >
              <img
                src={`${process.env.REACT_APP_STRAPI_URL}${featuredArticles[0].cover?.formats.medium.url}`}
                alt={featuredArticles[0].title}
                className="h-[214px] w-full rounded-[12px] object-cover lg:h-[296px]"
              />
              <div className="mt-2 flex flex-col gap-2 lg:mt-4">
                <p className="font-inter text-[20px] font-semibold leading-[120%] tracking-[-0.01em] text-strong-950">
                  {featuredArticles[0].title}
                </p>
                <p className="font-inter text-[16px] font-normal leading-[160%] tracking-[0em] text-[#404040] lg:tracking-[0em]">
                  {featuredArticles[0].description}
                </p>
                {/* <div className="flex flex-row justify-between">
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    By {featuredArticles[0].author}
                  </p>
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    {formatDate(featuredArticles[0].createdAt ?? "")}
                  </p>
                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mt-6 flex-1 lg:mt-0">
        <div className="flex flex-col gap-6">
          {featuredArticles.length > 1 && (
            <div
              className="flex cursor-pointer flex-row gap-2"
              onClick={() =>
                navigate(Routes.BLOG_POST(featuredArticles[1].slug ?? ""), {
                  state: {
                    article: featuredArticles[1],
                  },
                })
              }
            >
              <img
                src={`${process.env.REACT_APP_STRAPI_URL}${featuredArticles[1].cover?.formats.thumbnail.url}`}
                alt={featuredArticles[1].title}
                className="h-[100px] w-[100px] rounded-[12px] object-cover lg:h-[136px] lg:w-[131px]"
              />
              <div className="flex flex-col gap-2 lg:gap-2">
                <p className="font-inter text-[14px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950 lg:text-[20px]">
                  {featuredArticles[1].title}
                </p>
                <p className="font-inter text-[14px] font-normal leading-[100%] tracking-[0em] text-neutral-700 lg:text-[16px] lg:leading-[22px] lg:tracking-[-1.5%]">
                  {featuredArticles[1].description}
                </p>
                {/* <div className="flex flex-row justify-between">
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    By {featuredArticles[1].author}
                  </p>
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    {formatDate(featuredArticles[1].createdAt ?? "")}
                  </p>
                </div> */}
              </div>
            </div>
          )}
          {featuredArticles.length > 2 && (
            <div
              className="flex cursor-pointer flex-row gap-2"
              onClick={() =>
                navigate(Routes.BLOG_POST(featuredArticles[2].slug ?? ""), {
                  state: {
                    article: featuredArticles[2],
                  },
                })
              }
            >
              <img
                src={`${process.env.REACT_APP_STRAPI_URL}${featuredArticles[2].cover?.formats.thumbnail.url}`}
                alt={featuredArticles[2].title}
                className="h-[100px] w-[100px] rounded-[12px] object-cover lg:h-[136px] lg:w-[131px]"
              />
              <div className="flex flex-col gap-2 lg:gap-2">
                <p className="font-inter text-[14px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950 lg:text-[20px]">
                  {featuredArticles[2].title}
                </p>
                <p className="font-inter text-[14px] font-normal leading-[100%] tracking-[-0.01em] text-neutral-700 lg:text-[16px] lg:leading-[22px] lg:tracking-[-1.5%]">
                  {featuredArticles[2].description}
                </p>
                {/* <div className="flex flex-row justify-between">
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    By {featuredArticles[2].author}
                  </p>
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    {formatDate(featuredArticles[2].createdAt ?? "")}
                  </p>
                </div> */}
              </div>
            </div>
          )}
          {featuredArticles.length > 3 && (
            <div
              className="flex cursor-pointer flex-row gap-2"
              onClick={() =>
                navigate(Routes.BLOG_POST(featuredArticles[3].slug ?? ""), {
                  state: {
                    article: featuredArticles[3],
                  },
                })
              }
            >
              <img
                src={`${process.env.REACT_APP_STRAPI_URL}${featuredArticles[2].cover?.formats.thumbnail.url}`}
                alt={featuredArticles[2].title}
                className="h-[100px] w-[100px] rounded-[12px] object-cover lg:h-[136px] lg:w-[131px]"
              />
              <div className="flex flex-col gap-2 lg:gap-2">
                <p className="font-inter text-[14px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950 lg:text-[20px]">
                  {featuredArticles[2].title}
                </p>
                <p className="font-inter text-[14px] font-normal leading-[12px] tracking-[-1.5%] text-neutral-700 lg:text-[16px] lg:leading-[22px]">
                  {featuredArticles[2].description}
                </p>
                {/* <div className="flex flex-row justify-between">
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    By {featuredArticles[2].author}
                  </p>
                  <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-600">
                    {formatDate(featuredArticles[2].createdAt ?? "")}
                  </p>
                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedArticles;
